import { DependencyList, EffectCallback, useEffect, useRef } from 'react';

/**
 * `useEffect` with explicit control over the initial mount.
 *
 * @param runOnMount - Default `true`: same as `useEffect` (runs on mount and when `deps` change).
 *                     Pass `false` to skip the first run and only run when `deps` change after mount.
 */
export function useUpdateEffect(
  effect: EffectCallback,
  deps: DependencyList,
  runOnMount = true,
): void {
  const isFirstRun = useRef(true);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      if (!runOnMount) {
        return;
      }
    }
    return effect();
  }, deps);
}
